<template lang="pug">
shListData(title="Órdenes Mayoristas" resolver="orderWholesalers" keyData="order" component="shOrderWholesaler")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'OrdersWholesaler',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/orderWholesaler/OrderWholesalers.vue